import * as React from 'react';
import Box from '@mui/material/Box';
import { NewsFeedItem } from '../NewsApi';
import NewsFeedBellButton from './NewsFeedBellButton';
import NewsFeedPanel from './NewsFeedPanel';
import { NewsFeedLabels } from './newsFeedLabels';

type NewsFeedProps = {
    labels: NewsFeedLabels;
    newsItems: NewsFeedItem[];
    onMarkAsRead: (ids: number[]) => void;
};

export default function NewsFeed({ labels, newsItems, onMarkAsRead }: NewsFeedProps) {
    const [anchorElement, setAnchorElement] = React.useState<HTMLElement | null>(null);
    const unreadIds = newsItems.filter((item) => !item.isRead).map((item) => item.id);

    function handleClose() {
        setAnchorElement(null);
        if (unreadIds.length > 0) {
            onMarkAsRead(unreadIds);
        }
    }

    return (
        <Box sx={{ width: '24px', height: '24px' }}>
            <NewsFeedBellButton
                unreadCount={unreadIds.length}
                isOpen={Boolean(anchorElement)}
                labels={labels}
                onClick={(event) => setAnchorElement(event.currentTarget)}
            />
            <NewsFeedPanel
                anchorElement={anchorElement}
                newsItems={newsItems}
                labels={labels}
                onClose={handleClose}
            />
        </Box>
    );
}
